<cm-sidebar-layout>
    <cm-item-filters cm-filters>
        <cm-search-filter placeholder="Name, ..."></cm-search-filter>
        <cm-checkboxes-filter label="Account type" name="accountType" [options]="Labels.AccountType"></cm-checkboxes-filter>
        <cm-checkboxes-filter label="Status" name="includeInactive" [options]="Labels.IncludeInactive"></cm-checkboxes-filter>
    </cm-item-filters>
    <cm-infinite-list listType="grid" [count]="$totalCount()" [intersectionStatusChange]="$pageFilledStatusChange()" class="cm-items-list">
        <cm-list-info cm-list-header [parentList]="this" [count]="$totalCount()" [sortCriteria]="$sortCriteria()"></cm-list-info>
        @for (item of $items(); track item.trackId) {
            @if (item.data; as organization) {
                <cm-entity-card @fadeInCard [entity]="organization" [entityLink]="[organization.id]" [defaultSubtitle]="false">
                    <div cm-top-left class="cm-activity-chip" [class.cm-recently-active]="isRecentlyActive(organization.lastActiveAt)">
                        @if (organization.lastActiveAt) {
                            Last active: {{ organization.lastActiveAt | cmTimeAgo: true }}
                        } @else {
                            Never active
                        }
                    </div>
                    <ng-container cm-subtitle>
                        <div class="cm-url">
                            {{ organization.url }}
                        </div>
                    </ng-container>
                </cm-entity-card>
            } @else if (item.placeholder) {
                <cm-card-placeholder @fadeInPlaceholder></cm-card-placeholder>
            } @else if (item.error) {
                <cm-card-error @fadeInPlaceholder></cm-card-error>
            }
        }
    </cm-infinite-list>
</cm-sidebar-layout>
<router-outlet></router-outlet>
